import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/about/bloom-chat-conversation 1.png")